// https://stackoverflow.com/questions/18017869/build-tree-array-from-flat-array-in-javascript
export function convertFlatMenuToStructuredTree(list) {
    let map = {},
        node,
        roots = [],
        i

    for (i = 0; i < list.length; i += 1) {
        map[list[i].id] = i
        list[i].pages = []
    }

    for (i = 0; i < list.length; i += 1) {
        node = list[i]
        if (node.parent !== null) {
            // menu queries ask for parent(status: null), so children of a disabled parent
            // point at an id missing from the list and are hidden with it
            if (map[node.parent.id] !== undefined) {
                list[map[node.parent.id]].pages.push(node)
            }
        } else {
            roots.push(node)
        }
    }
    return roots
}

export function filterMenuByUserStatus(menuItems, user) {
    const userStatusFilter = user?.isLoggedIn ? "loggedOutOnly" : "loggedInOnly"

    const filterItem = menuItem => {
        if (menuItem.userStatus === "crfStaffOnly" && !user?.isCrfStaff) return []
        if (menuItem.userStatus === userStatusFilter) return []

        menuItem.pages = menuItem.pages.flatMap(filterItem)

        return menuItem
    }

    return menuItems.flatMap(filterItem)
}

export function scrollTo(element, adjustment = 0) {
    // Offset by whichever header pins to the top of the viewport:
    // - TCT2026 layout pins .siteHeader__content (desktop only; it flags itself
    //   with data-fixed-eligible). Its rect.bottom equals the pinned bottom even
    //   before it goes fixed, so this works whether or not the page is scrolled yet.
    // - All other layouts use .menubar (unchanged behavior).
    const stickyBar = document.querySelector('.siteHeader__content[data-fixed-eligible="true"]')
    const headerBottom = stickyBar
        ? stickyBar.getBoundingClientRect().bottom
        : document.getElementsByClassName("menubar")[0]?.getBoundingClientRect().bottom || 0
    const y = element.getBoundingClientRect().top + window.scrollY - headerBottom + adjustment
    window.scrollTo({ top: y, behavior: "smooth" })
}

export function getModerators(event, rolesCSV, rolesAdditionalCSV) {
    let _customModerators = []
    let _standardModerators = []

    if (rolesCSV || rolesAdditionalCSV) {
        const combinedModeratorRolesCsv = [rolesCSV, rolesAdditionalCSV].join(",")
        const rolesArray = combinedModeratorRolesCsv?.split(",").map(role => role.trim())
        _customModerators = event.moderators.reduce((all, group) => {
            if (rolesArray.includes(group.role.name)) {
                return [...all, ...group.users]
            }
            return all
        }, [])
    }

    // if standard roles were not overridden, then add them
    if (!rolesCSV) {
        // get all faculty in a role slug that includes 'moderator'
        _standardModerators = event.moderators.reduce((all, group) => {
            if (group.role?.slug?.includes("moderator")) {
                return [...all, ...group.users]
            }
            return all
        }, [])
    }

    // merge both arrays and remove duplicates
    const result = [...new Set([..._standardModerators, ..._customModerators])]

    // If no moderators found directly, fall back to children
    if (result.length === 0 && event.children?.length > 0) {
        return event.children.flatMap(child => getModerators(child, rolesCSV, rolesAdditionalCSV))
    }

    return result
}

// map of faculty id => role name for faculty in one of the additional moderator roles, e.g. { 10112: "Whiteboard Presenter" }
// (includes children, matching getModerators' fallback)
export function getAdditionalModeratorRoles(event, rolesAdditionalCSV) {
    if (!rolesAdditionalCSV) return {}

    const rolesArray = rolesAdditionalCSV.split(",").map(role => role.trim())
    const groups = [...(event.moderators || []), ...(event.children || []).flatMap(child => child.moderators || [])]

    return groups.reduce((all, group) => {
        if (rolesArray.includes(group.role?.name)) {
            group.users.forEach(user => {
                all[user.id] = group.role.name
            })
        }
        return all
    }, {})
}

export function getDiscussants(event, rolesCSV, rolesAdditionalCSV) {
    let _customDiscussants = []
    let _standardDiscussants = []

    if (rolesCSV || rolesAdditionalCSV) {
        const combinedModeratorRolesCsv = [rolesCSV, rolesAdditionalCSV].join(",")
        const rolesArray = combinedModeratorRolesCsv?.split(",").map(role => role.trim())
        _customDiscussants = event.moderators.reduce((all, group) => {
            if (rolesArray.includes(group.role.name)) {
                return [...all, ...group.users]
            }
            return all
        }, [])
    }

    // if standard roles were not overridden, then add them
    if (!rolesCSV) {
        // default discussant logic:
        // get all faculty in a role that contains 'discussant' AND (either not 'monitor' or does include 'chat-monitor'
        // cap array length at 6
        _standardDiscussants = event.moderators
            .reduce((all, group) => {
                if (
                    group.role?.slug?.includes("discussant") &&
                    (!group.role?.slug?.includes("monitor") || group.role?.slug?.includes("chat-monitor"))
                ) {
                    return [...all, ...group.users]
                }
                return all
            }, [])
            .slice(0, 6)
    }

    return [...new Set([..._standardDiscussants, ..._customDiscussants])]
}
